import Vue from 'vue'
import fetchMixin from '@/utils/fetch-mixin'
Vue.mixin(fetchMixin)
